/**
 * OSK volby
 */

import * as state from "../../../lib/state";
import * as api from "../../../lib/api";
import * as context from "../../../context";
import * as common from "../../../lib/common";
import * as apiDynamicLists from "../../shared/dynamic-lists/api-dynamic-lists";

/**
 * Stav modulu
 */
export interface State {
	data: string;
	justLoading: boolean;
}

export class Model implements state.StateModel {
	stateContainer: state.StateContainer<State>;

	constructor(private context: context.StateContext) {
		this.stateContainer = new state.StateContainer<State>({
			data: "",
			justLoading: false
		}, context);
	}

	/**
	 * Vrací kolekci stavových kontejnerů
	 */
	getStateContainers = () => [
		this.stateContainer
	]

	loadData = async () => {
		const elections = await common.withIndication({
			indicateStart: () => this.stateContainer.merge(_ => ({ justLoading: true })),
			exec: () => this.context.api.post("/regional_chamber/elections", {}),
			finish: () => this.stateContainer.merge(_ => ({ justLoading: false }))
		}) as { data: any };
		await this.stateContainer.merge(_ => ({
			data: elections.data
		}));
	}

	getData = () => this.stateContainer.get().data;

}